// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-menu-box {\n  box-sizing: content-box;\n}\n.item-menu-box li {\n  padding: 0 5px 0 25px;\n  cursor: pointer;\n  line-height: 25px;\n}\n.item-menu-box li:hover {\n  background-color: #eee;\n}", ""]);
// Exports
module.exports = exports;
